import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';

import { DatadogLogger } from '@ninety/platform/services/vendor/datadog';

import { OfflineService } from '../services/offline.service';

export function ErrorInterceptor(request: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
  const injector = inject(Injector);
  const datadogLogger = inject(DatadogLogger);

  return next(request).pipe(
    catchError((caughtError: unknown) => {
      const err: any = caughtError;
      const { errorMessage = null } = parseErrorBody(err?.error?.body);
      if (err?.error?.errorId)
        datadogLogger.error({
          message: 'http_request_error',
          error: err,
          data: {
            url: err?.url,
            requestId: request.headers.get('x-ninety-request-id'),
            errorId: err?.error?.errorId,
          },
        });
      const error = {
        ...err,
        toString: () => `${err.error.message || err.error.errorMessage || errorMessage || err.statusText || ''}`,
      };

      const offlineService = injector.get(OfflineService);
      if (!offlineService.isOffline$.value && err?.status === 0) offlineService.check().subscribe();

      return throwError(() => error);
    })
  );
}

function parseErrorBody(body: unknown): { errorMessage?: string | null } {
  if (!body || typeof body !== 'string') {
    return {};
  }

  try {
    return JSON.parse(body);
  } catch {
    return {};
  }
}
